import { createContentPropTypes } from '../../helpers/content';

const reviewPayments = {
	title: 'Processing {{items}} payments',
	subTitle: [
		"We're now processing each payment. If there are no problems, we'll go ahead with making these payments.",
		'Larger files may take longer as we process each new payment.',
	],
	warningText: "Please make sure you don't close or refresh this page or you'll have to start again.",
	activityText: 'Processing',
};
const checkPayees = {
	title: 'Checking {{items}} payees',
	subTitle: [
		"We're now checking each payee's account details. If there are no problems or duplicates, they'll be created as new payees on your list.",
		'Larger files may take longer as we check and create each new payee.',
	],
	warningText: "Please don't close this window or leave internet banking until this is done.",
	activityText: 'Checking',
};

export default {
	reviewPayments,
	checkPayees,
};

export const contentPropTypes = createContentPropTypes(reviewPayments);
